import { IIcon } from '@/types/generalTypes';

const WorkflowSquareIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1196_4273)'>
        <path
          d='M6 3.33337C6 2.39056 6 1.91916 6.29289 1.62627C6.58579 1.33337 7.05719 1.33337 8 1.33337C8.94281 1.33337 9.41421 1.33337 9.70711 1.62627C10 1.91916 10 2.39056 10 3.33337C10 4.27618 10 4.74759 9.70711 5.04048C9.41421 5.33337 8.94281 5.33337 8 5.33337C7.05719 5.33337 6.58579 5.33337 6.29289 5.04048C6 4.74759 6 4.27618 6 3.33337Z'
          stroke='currentColor'
          strokeWidth='1.2'
        />
        <path
          d='M1.33301 12.6667C1.33301 11.7239 1.33301 11.2525 1.6259 10.9596C1.91879 10.6667 2.3902 10.6667 3.33301 10.6667C4.27582 10.6667 4.74722 10.6667 5.04011 10.9596C5.33301 11.2525 5.33301 11.7239 5.33301 12.6667C5.33301 13.6096 5.33301 14.081 5.04011 14.3739C4.74722 14.6667 4.27582 14.6667 3.33301 14.6667C2.3902 14.6667 1.91879 14.6667 1.6259 14.3739C1.33301 14.081 1.33301 13.6096 1.33301 12.6667Z'
          stroke='currentColor'
          strokeWidth='1.2'
        />
        <path
          d='M10.6665 12.6667C10.6665 11.7239 10.6665 11.2525 10.9594 10.9596C11.2523 10.6667 11.7237 10.6667 12.6665 10.6667C13.6093 10.6667 14.0807 10.6667 14.3736 10.9596C14.6665 11.2525 14.6665 11.7239 14.6665 12.6667C14.6665 13.6096 14.6665 14.081 14.3736 14.3739C14.0807 14.6667 13.6093 14.6667 12.6665 14.6667C11.7237 14.6667 11.2523 14.6667 10.9594 14.3739C10.6665 14.081 10.6665 13.6096 10.6665 12.6667Z'
          stroke='currentColor'
          strokeWidth='1.2'
        />
        <path
          d='M7.99967 5.33337V6.00004M7.99967 6.00004C7.99967 6.6213 7.99967 6.93192 8.11808 7.17695C8.27596 7.50366 8.57879 7.76322 8.95994 7.89855C9.24581 8.00004 9.60821 8.00004 10.333 8.00004C11.0578 8.00004 11.4202 8.00004 11.7061 8.10153C12.0872 8.23686 12.3901 8.49643 12.5479 8.82313C12.6663 9.06816 12.6663 9.37879 12.6663 10V10.6667M7.99967 6.00004C7.99967 6.6213 7.99967 6.93192 7.88126 7.17695C7.72339 7.50366 7.42056 7.76322 7.0394 7.89855C6.75354 8.00004 6.39114 8.00004 5.66634 8.00004C4.94154 8.00004 4.57914 8.00004 4.29328 8.10153C3.91212 8.23686 3.6093 8.49643 3.45142 8.82313C3.33301 9.06816 3.33301 9.37879 3.33301 10V10.6667'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1196_4273'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WorkflowSquareIcon;
